import { size } from 'lodash';
import React, { useMemo } from 'react';

import { MenuItem } from '@mui/material';

import * as Models from 'contracts/models';
import LicenseCreditBar from 'pages/components/AuthWidget/components/LicenseCreditBar';
import LicenseIssue from 'pages/components/AuthWidget/components/LicenseIssue';
import { formatLicenseName } from 'pages/components/AuthWidget/utils';

import useStyles from './styles';

interface Props {
    license: Models.UserInfo.License;
    onSelectClick?: (license: Models.UserInfo.License) => void;
    onIssueClick?: () => void;
    active?: boolean;
    readOnly?: boolean;
    disabled?: boolean;
    className?: string;
}

const LicenseMenuItem: React.FC<Props> = ({
    license,
    readOnly,
    disabled,
    active,
    onSelectClick,
    onIssueClick,
    className
}) => {
    const { classes, cx } = useStyles({ active });
    const isShared = useMemo(() => size(license.members) > 1, [license.members]);

    return (
        <>
            <MenuItem
                component="button"
                disableGutters
                centerRipple
                disableRipple
                disabled={disabled}
                className={cx(classes.root, className)}
                onClick={readOnly ? undefined : () => onSelectClick?.(license)}
            >
                <div className={classes.line}>
                    <span className={classes.name}>{formatLicenseName(license)}</span>
                    {isShared ? <span className={classes.tag}>{'Shared'}</span> : null}
                    {readOnly ? null : <span data-role="radio" className={classes.radio} />}
                </div>
                <LicenseCreditBar license={license} />
            </MenuItem>
            <LicenseIssue license={license} className={classes.issue} onClick={onIssueClick} />
        </>
    );
};

export default LicenseMenuItem;
